
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  skipLLM: true,
  maxTocLevel: 4,
  description: "Instantly make your card top-of-wallet at merchants with Knot's API"
};
export const partnerProps = {
  partner: 'Knot',
  clientLibrary: 'knot',
  subtitle: metadata.description,
  registrationUrl: 'https://www.knotapi.com/demo/',
  apiUrl: 'https://docs.knotapi.com/docs',
  isPaymentProcessor: false
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Knot and Plaid have partnered to offer a seamless and secure solution for managing card-on-file information across a vast network of merchants. Knot's CardSwitcher™ effortlessly automates the process of adding or updating a cardholder's credit or debit card at almost any merchant, ensuring that your card remains top-of-wallet. Knot Customers can use Plaid's transaction data to suggest hyper-relevant CardSwitches that are personalized based on a cardholder's transaction history.`}</p>
    <p>{`Utilizing Knot's CardSwitcher™, card issuers can now automate the entire lifecycle of a cardholder. From initial issuance, through card replacements, and card expirations, all while remaining top-of-wallet. The integration with Plaid further enhances this process by providing Knot customers with transaction history that allows cardholders to receive personalized CardSwitcher suggestions.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.TransactionsInstructions {...partnerProps} />
    <Partnership.TransactionsServer {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.TransactionsConclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
